import { ChangePasswordDto } from '../../model/settings/dto/ChangePasswordDto';
import { GenericWithUserId } from '../../model/shared/dto/GenericWithUserId';
import { User } from '../../model/user/User';
import { CodeVerifyDto } from '../../model/user/dto/CodeVerifyDto';
import { CreateLoginWithGoogleLinkDto } from '../../model/user/dto/CreateLoginWithGoogleLink';
import { ForgotPasswordEmailDto } from '../../model/user/dto/ForgotPasswordEmailDto';
import { ForgotPasswordNewPasswordDto } from '../../model/user/dto/ForgotPasswordNewPasswordDto';
import { ForgotPasswordTokenDto } from '../../model/user/dto/ForgotPasswordTokenDto';
import { LoginDto } from '../../model/user/dto/LoginDto';
import { LoginResponseDto } from '../../model/user/dto/LoginResponseDto';
import { LoginWithGoogleDto } from '../../model/user/dto/LoginWithGoogleDto';
import { SignupDto } from '../../model/user/dto/SignupDto';
import { SignupSuccessDto } from '../../model/user/dto/SignupSuccessDto';
import { UpdateUserDto } from '../../model/user/dto/UpdateUserDto';
import { UpdateUserEmailNewEmailDto } from '../../model/user/dto/UpdateUserEmailNewEmailDto';
import { UpdateUserEmailPasswordDto } from '../../model/user/dto/UpdateUserEmailPasswordDto';
import { UpdateUserEmailVerifyCodeDto } from '../../model/user/dto/UpdateUserEmailVerifyCodeDto';
import { AtiraApi } from '../AxiosClient';

export class UserAxios {
  static login(dto: LoginDto) {
    return AtiraApi.post<LoginResponseDto>(`/auth/login`, dto).then(
      ({ data }) => data,
    );
  }

  static forgotPasswordEmail(dto: ForgotPasswordEmailDto) {
    return AtiraApi.post<void | string>(
      '/auth/forgot-password/email',
      dto,
    ).then(({ data }) => data);
  }

  static forgotPasswordToken(dto: ForgotPasswordTokenDto) {
    return AtiraApi.post<void>('/auth/forgot-password/token', dto).then(
      ({ data }) => data,
    );
  }

  static forgotPasswordNewPassword(dto: ForgotPasswordNewPasswordDto) {
    return AtiraApi.post<void>('/auth/forgot-password/new', dto).then(
      ({ data }) => data,
    );
  }

  static signup(dto: SignupDto) {
    return AtiraApi.post(`/auth/signup`, dto).then(({ data }) => data);
  }

  static verifyUserAccount(dto: CodeVerifyDto) {
    return AtiraApi.post<SignupSuccessDto>(`/auth/code-verify`, dto).then(
      ({ data }) => data,
    );
  }

  static loginWithGoogle(dto: LoginWithGoogleDto) {
    return AtiraApi.post<SignupSuccessDto>(`/auth/google`, dto).then(
      ({ data }) => data,
    );
  }

  static getLoggedInUser(userId: string) {
    return AtiraApi.get<User>(`/user/${userId}`).then(({ data }) => data);
  }

  static createLoginWithGoogleLink(dto: CreateLoginWithGoogleLinkDto) {
    return AtiraApi.post(`/auth/create-google-auth-link`, dto).then(
      ({ data }) => data,
    );
  }

  static updateUserInfo(dto: UpdateUserDto) {
    return AtiraApi.patch(`/user/${dto.userId}`, dto).then(({ data }) => data);
  }

  static updateUserEmailPassword(dto: UpdateUserEmailPasswordDto) {
    return AtiraApi.post<void>(`/auth/change-email/start`, dto).then(
      ({ data }) => data,
    );
  }

  static updateUserEmailNewEmail(dto: UpdateUserEmailNewEmailDto) {
    return AtiraApi.post<void>(`/auth/change-email/email`, dto).then(
      ({ data }) => data,
    );
  }

  static updateUserEmailVerifyCode(dto: UpdateUserEmailVerifyCodeDto) {
    return AtiraApi.post(`/auth/change-email/token`, dto).then(
      ({ data }) => data,
    );
  }

  static updateUserPassword(dto: ChangePasswordDto) {
    return AtiraApi.post(`/auth/change-password`, dto).then(({ data }) => data);
  }

  static undoDeleteUser(dto: GenericWithUserId) {
    return AtiraApi.post(`/user/${dto.userId}/mark-for-deletion/undo`).then(
      ({ data }) => data,
    );
  }

  static markUserForDeletion(dto: GenericWithUserId) {
    return AtiraApi.post(`/user/${dto.userId}/mark-for-deletion`).then(
      ({ data }) => data,
    );
  }
}
